import { isElementType } from "@testing-library/user-event/dist/utils";
import React from "react";
import { config } from "../../data/config";

function Projects() {
  const { projects } = config;
  return (
    <div className="border-t border-gray-200 text-gray-700 body-font">
      <div className="container mx-auto py-6">
        <p className="font-bold mb-4 text-black text-2xl text-center">
          <span
            style={{
              backgroundImage:
                "linear-gradient(120deg, #84fab0 0%, #6366f1 100%)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 0.2em",
              backgroundPosition: "0 88%",
              transition: "background-size 0.25s ease-in",
            }}
            className="dark:text-white"
          >
            Projects
          </span>
        </p>
        <p className="text-center text-sm dark:text-slate-400">Some of my projects :</p>
        <div className="flex flex-wrap m-4">
          {projects.map((project, idx) => (
            <div className="p-4 md:w-1/2" key={idx}>
              <div className="flex rounded-lg h-full bg-gray-100 dark:bg-slate-800 dark:border-gray-500 dark:border p-8 flex-col">
                <div className="flex items-center mb-3">
                  <div className="w-8 h-8 mr-3 inline-flex items-center justify-center rounded-full bg-indigo-500  text-white flex-shrink-0">
                    {idx + 1}
                  </div>
                  <h2 className="text-gray-900 text-lg dark:text-white title-font font-medium">
                    {project.title}
                  </h2>
                </div>
                <div className="flex-grow">
                  <p className="leading-relaxed text-base dark:text-slate-400">{project.desc}</p>
                  <p className="leading-relaxed text-base mt-3 text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 inline-block"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {project.languages.map((lang , idx) => (
                      <span className="inline-bolock bg-gray-200 mx-1 p-1 rounded" key={idx}>
                        {lang}
                      </span>
                    ))}
                  </p>
                  <a
                    href={project.url_github}
                    className="mt-3 text-dark dark:text-slate-200 font-bold inline-flex items-center"
                    style={{
                      backgroundImage:
                        "linear-gradient(120deg, #6366f1 0%, #84fab0 100%)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "100% 0.2em",
                      backgroundPosition: "0 88%",
                      transition: "background-size 0.25s ease-in",
                    }}
                  >
                    Visit Github
                  </a>
                 {project?.url &&  (<a
                    href={project?.url}
                    className="mt-3 text-dark dark:text-slate-200 border-b font-bold mx-3 inline-flex items-center"
                    style={{
                      backgroundImage:
                        "linear-gradient(120deg, #84fab0 0%, #6366f1 100%)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "100% 0.2em",
                      backgroundPosition: "0 88%",
                      transition: "background-size 0.25s ease-in",
                    }}
                  >
                    Visit Site
                  </a>)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;
